import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b1c6530&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b1c6530&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c6530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1c6530')) {
      api.createRecord('0b1c6530', component.options)
    } else {
      api.reload('0b1c6530', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b1c6530&scoped=true", function () {
      api.rerender('0b1c6530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cc_message-dash/index.vue"
export default component.exports